import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {capitalize} from 'lodash';
import {renderMoment} from 'lib/timeUtils';
import {Link} from 'react-router';

import {MandarkTable, Icon, Button, Heading} from '@albert-io/atomic';

import {
  getPendingSearchFilters,
  getPendingInvitations,
  resendInvite,
  resendAll
} from 'client/SchoolAdministration/School/ManageStaff/Staff/manageStaffUtils';

import DeleteInvitationModal from './DeleteInvitationModal.react';

const PendingInvitations = ({params}) => {
  const [staffInviteToDelete, setStaffInviteToDelete] = useState(null);
  return (
    <div className='manage-staff__table u-mar-t_4'>
      <MandarkTable
        query={getPendingInvitations(params.schoolId)}
        searchFilters={getPendingSearchFilters}
        searchPlaceholder='Search'
        title='Staff Members'
        defaultSortDirection='ASCENDING'
        persistSearch
        persistPage
        dataMutator={(school) => school.getSchoolPersonnelInvitations()}
        customEmptyTable={
          <div className='u-text-align_center'>
            <Heading size='s' className='u-mar-t_4'>
              No Pending Invitations Staff Members
            </Heading>
          </div>
        }
        buttonGroup={[
          <Button variant='text' onClick={() => resendAll(params.schoolId)}>
            <Icon icon={['far', 'envelope']} className='u-mar-r_1' />
            Resend All
          </Button>,
          <Button as={Link} to={`/school-admin/${params.schoolId}/update-teachers`}>
            <Icon icon={['far', 'user-plus']} className='u-mar-r_1' />
            Update Teacher List
          </Button>
        ]}
      >
        <MandarkTable.Column
          defaultSortParam
          heading='Email'
          content={(staff) => {
            // If statement (L56) refers to cases where the user is still labeled as a teacher but is not associated with the TeacherModelV1 object.
            // Their role was presumably changed to a student.
            // If statement (L61) refers to cases where the user is not a teacher. Admin has sent user an invite but it hasn't been accepted yet.
            if (staff.has('teacher') && staff.getTeacher().size === 0) {
              return (
                <div className='manage-staff__personnel-invitation-name'>Email not available</div>
              );
            }
            if (!staff.has('teacher')) {
              return staff.getEmail();
            }
            return staff.getTeacher().getEmail();
          }}
          className='u-word-break_break-all'
          sortBy='teacher_v1.email'
        />
        <MandarkTable.Column
          heading='Name'
          content={(staff) => {
            const sentDate =
              !staff.has('teacher') && staff.getSentEmailAt()
                ? ` Last sent ${renderMoment(staff.getSentEmailAt())}`
                : ' Queued for delivery';

            if (staff.has('teacher') && staff.getTeacher().size === 0) {
              return (
                <div className='manage-staff__personnel-invitation-name'>
                  This user has switched their account type to student.
                </div>
              );
            }
            if (!staff.has('teacher')) {
              return (
                <div className='manage-staff__personnel-invitation-name'>
                  The owner of this email hasn&apos;t created an account yet.
                  <span className='manage-staff__personnel-invitation-date-sent'>{sentDate}</span>
                </div>
              );
            }
            return staff.getTeacher().getFullName({formal: true});
          }}
          sortBy='teacher_v1.last_name'
        />
        <MandarkTable.Column
          heading='Invitation Sent'
          content={(staff) =>
            staff.has('teacher') ? capitalize(staff.getRole()?.get('title')) : 'Teacher'
          }
          sortBy='role_v1.title'
        />
        <MandarkTable.Column
          content={(staff) => {
            return (
              <div>
                <Button size='s' variant='text' onClick={() => resendInvite(staff)}>
                  <Icon icon={['far', 'envelope']} className='u-mar-r_1' />
                  Resend
                </Button>
                <Button
                  color='destructive'
                  size='s'
                  variant='text'
                  onClick={() => {
                    setStaffInviteToDelete(staff);
                  }}
                >
                  <Icon icon={['far', 'xmark']} className='u-mar-r_1' />
                  Reject
                </Button>
              </div>
            );
          }}
          align='right'
          className='manage-staff__action-buttons'
        />
      </MandarkTable>
      {staffInviteToDelete && (
        <DeleteInvitationModal
          setStaffInviteToDelete={setStaffInviteToDelete}
          staffInviteToDelete={staffInviteToDelete}
          params={params}
        />
      )}
    </div>
  );
};

PendingInvitations.propTypes = {
  params: PropTypes.object
};

export default PendingInvitations;
